// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kK0_y","clinicsSelect":"styles_clinicsSelect__1J4UC"};